/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminResetPassword } from '../models/AdminResetPassword';
import type { CompanyRequest } from '../models/CompanyRequest';
import type { CompanyResponse } from '../models/CompanyResponse';
import type { Employee } from '../models/Employee';
import type { ExtendEmployee } from '../models/ExtendEmployee';
import type { Forgot } from '../models/Forgot';
import type { PaginatedEmployeeList } from '../models/PaginatedEmployeeList';
import type { PaginatedGroupList } from '../models/PaginatedGroupList';
import type { PatchedCompanyRequest } from '../models/PatchedCompanyRequest';
import type { PatchedEmployeesPatch } from '../models/PatchedEmployeesPatch';
import type { ResetPassword } from '../models/ResetPassword';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CompanyService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * image: registration_document, representative_id_card_front, representative_id_card_back, account_image
     *
     * status: 0(新增公司未送審), 1(送審中) 2(審核通過)
     *
     * address 存放json dict
     * @param requestBody
     * @returns CompanyResponse
     * @throws ApiError
     */
    public companyCreate(
        requestBody: CompanyRequest,
    ): CancelablePromise<CompanyResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/company/',
            body: requestBody,
            mediaType: 'multi-part/form-data',
        });
    }

    /**
     * image: registration_document, representative_id_card_front, representative_id_card_back, account_image
     *
     * status: 0(新增公司未送審), 1(送審中) 2(審核通過)
     *
     * address 存放json dict
     * @param id
     * @returns CompanyResponse
     * @throws ApiError
     */
    public companyRetrieve(
        id: number,
    ): CancelablePromise<CompanyResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/company/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * image: registration_document, representative_id_card_front, representative_id_card_back, account_image
     *
     * status: 0(新增公司未送審), 1(送審中) 2(審核通過)
     *
     * address 存放json dict
     * @param id
     * @param requestBody
     * @returns CompanyResponse
     * @throws ApiError
     */
    public companyPartialUpdate(
        id: number,
        requestBody?: PatchedCompanyRequest,
    ): CancelablePromise<CompanyResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/company/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'multi-part/form-data',
        });
    }

    /**
     * @param requestBody
     * @returns any No response body
     * @throws ApiError
     */
    public companyAdminResetPasswordCreate(
        requestBody?: AdminResetPassword,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/company/admin_reset_password/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public companyCheckUserStatusRetrieve(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/company/check_user_status/',
        });
    }

    /**
     * 網址上帶的id是員工列表回傳裡的id 不是user
     *
     * status 0尚未驗證 1驗證 2凍結
     * @param page A page number within the paginated result set.
     * @returns PaginatedEmployeeList
     * @throws ApiError
     */
    public companyEmployeeList(
        page?: number,
    ): CancelablePromise<PaginatedEmployeeList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/company/employee/',
            query: {
                'page': page,
            },
        });
    }

    /**
     * 網址上帶的id是員工列表回傳裡的id 不是user
     *
     * status 0尚未驗證 1驗證 2凍結
     * @param twid twid_record
     * @param requestBody
     * @returns Employee
     * @throws ApiError
     */
    public companyEmployeeCreate(
        twid?: string,
        requestBody?: ExtendEmployee,
    ): CancelablePromise<Employee> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/company/employee/',
            query: {
                'twid': twid,
            },
            body: requestBody,
            mediaType: 'multi-part/form-data',
        });
    }

    /**
     * 網址上帶的id是員工列表回傳裡的id 不是user
     *
     * status 0尚未驗證 1驗證 2凍結
     * @param id
     * @returns Employee
     * @throws ApiError
     */
    public companyEmployeeRetrieve(
        id: number,
    ): CancelablePromise<Employee> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/company/employee/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * 網址上帶的id是員工列表回傳裡的id 不是user
     *
     * status 0尚未驗證 1驗證 2凍結
     * @param id
     * @param requestBody
     * @returns Employee
     * @throws ApiError
     */
    public companyEmployeePartialUpdate(
        id: number,
        requestBody?: PatchedEmployeesPatch,
    ): CancelablePromise<Employee> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/company/employee/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'multi-part/form-data',
        });
    }

    /**
     * 網址上帶的id是員工列表回傳裡的id 不是user
     *
     * status 0尚未驗證 1驗證 2凍結
     * @param id
     * @returns void
     * @throws ApiError
     */
    public companyEmployeeDestroy(
        id: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/company/employee/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any No response body
     * @throws ApiError
     */
    public companyForgetPasswordCreate(
        requestBody?: Forgot,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/company/forget_password/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param page A page number within the paginated result set.
     * @returns PaginatedGroupList
     * @throws ApiError
     */
    public companyGroupList(
        page?: number,
    ): CancelablePromise<PaginatedGroupList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/company/group/',
            query: {
                'page': page,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any No response body
     * @throws ApiError
     */
    public companyResetPasswordCreate(
        requestBody?: ResetPassword,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/company/reset_password/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public companyReviewPassReqRetrieve(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/company/review_pass_req/',
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public companyReviewSubmitCreate(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/company/review_submit/',
        });
    }

}
